import { SiteEventCloseDialogPlugin } from './SiteEventCloseDialogPlugin';
import { SiteEventDialogPlugin } from './SiteEventOpenDialogPlugin';
import { SiteEventRoutePlugin } from './SiteEventRoutePlugin';
export const defaultSiteEventPlugins = [
    SiteEventDialogPlugin,
    SiteEventCloseDialogPlugin,
    SiteEventRoutePlugin
];
//# sourceMappingURL=default.js.map